module.exports = __webpack_public_path__ + "static/media/3c2ce4428c2c44824b07162f648524f5.3c2ce442.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/3c2ce4428c2c44824b07162f648524f5.svg
// module id = 1240
// module chunks = 21